import React from "react";
import { useT } from "@/lib/LanguageContext";
import LoadFailure from "../../../components/ui/LoadFailure";
import { crmErrorMessage } from "../api/crmErrors";

/**
 * "This could not be read" — never an empty list (BUG-051). The product's own
 * `LoadFailure` panel, with the CRM's sentence for the refusal and the retry.
 */
export default function CrmLoadFailure({ error, onRetry, className, testId }) {
  const t = useT("crm");
  const tc = useT("common");
  if (!error) return null;
  return (
    <LoadFailure
      message={crmErrorMessage(error, t, tc, "errors.loadFailed")}
      onRetry={onRetry}
      retryLabel={t("common.retry")}
      testId={testId}
      retryTestId={testId ? `${testId}-retry` : undefined}
      className={className}
    />
  );
}
